module.exports = __webpack_public_path__ + "img/samllrt_sample.573d388a.png";